export default __webpack_public_path__ + "static/punjabsweet-a52a02ffc8f57bb3951111def73fb38e.png";